<template>
  <div>
    <Form ref="searchForm" inline :label-width="80" class="search-form">
      <Form-item label="敏感词名称">
        <Input
          style="width:200px"
          placeholder="请输入敏感词名称"
          v-model="searchCondition.name"
          clearable
          @keydown.native.prevent.enter="search(1)"
        />
      </Form-item>
      <Form-item class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="search(1)">搜索</Button>
          <Button icon="md-undo" @click="search(0)">重置</Button>
        </div>
      </Form-item>
    </Form>
    <Button style="margin-right:20px;" type="primary" @click="createSensitiveWords">新增敏感词</Button>
    <Button type="primary" @click="onImport()" class="btn-margin-right">批量导入</Button>
    <div class="content">
      <Grid
        ref="grid"
        :columns="column"
        data-url="/api/sensitiveWords"
        :search="searchCondition"
        :rowsFormatter="rowsFormatter"
        @onSelectionChange="onSelectionChange"
        selectType="multi"
        keyField="id"
      >
        <template slot-scope="{ row }" slot="action">
          <Button type="text" size="small" @click="editSensitiveWords(row.id)">编辑</Button>-
          <Button type="text" size="small" @click="del('one',row.id)">删除</Button>
        </template>
        <template slot="footer-left">
          <div class="button-group">
            <Button :disabled="selectList.length == 0" @click="del('all','')">删除</Button>
          </div>
        </template>
      </Grid>
    </div>
    <Modal v-model="showCreateWords" title="新增敏感词" width="600" scrollable>
      <Form ref="wordsForm" :rules="ruleValidate" :model="wordsInfo" :label-width="120">
        <FormItem label="敏感词名称" prop="name">
          <Input
            style="width:300px"
            type="text"
            v-model="wordsInfo.name"
            placeholder="请输入敏感词名称"
            :maxlength="15"
          />
        </FormItem>
        <FormItem label="添加原因" prop="remark">
          <Input
            style="width:300px"
            type="textarea"
            v-model="wordsInfo.remark"
            placeholder="请输入添加原因"
            :maxlength="200"
          />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="showCreateWords=false">取消</Button>
        <Button type="primary" size="large" @click="submitForm('wordsForm')">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  name: "SettingAccount",
  data() {
    return {
      showCreateWords: false,
      column: [
        {
          title: "敏感词名称",
          key: "name",
          align: "center",
          minWidth: 160
        },
        {
          title: "创建人",
          key: "nickname",
          align: "center",
          minWidth: 130
        },
        {
          title: "更新时间",
          key: "updated_at_name",
          align: "center",
          minWidth: 160
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          minWidth: 120,
          fixed: "right"
        }
      ],
      selectList: [],
      searchCondition: {
        name: ""
      },
      wordsInfo: {
        id: "",
        name: "",
        remark: ""
      },
      ruleValidate: {
        name: [
          {
            required: true,
            message: "敏感词不能为空",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    rowsFormatter(rows) {
      rows.forEach(i => {
        i.updated_at_name = this.$pub.timestampToTime(i.updated_at);
      });
    },
    search(flag) {
      if (flag == 0) {
        this.searchCondition.name = "";
      }
      this.$refs.grid.searchRefresh();
    },
    onSelectionChange(val) {
      this.selectList = val;
    },
    createSensitiveWords() {
      this.showCreateWords = true;
      this.wordsInfo.id = "";
      this.wordsInfo.name = "";
      this.wordsInfo.remark = "";
    },
    del(_type, _id) {
      let ids = "";
      if (_type == "one") {
        ids = _id;
      } else {
        if (this.selectList.length == 0) {
          this.$Message.error("请至少选择一个敏感词");
          return;
        }
        let arr = [];
        this.selectList.forEach(i => {
          arr.push(i.id);
        });
        ids = arr.join(",");
      }
      this.$Modal.confirm({
        title: "删除",
        content: "确定要删除该敏感词吗？",
        onOk: async () => {
          await this.delete(ids);
        },
        onCancel: () => {}
      });
    },
    onImport() {
      this.$router.push({
        name: "SensitiveWordsImports",
        query: {
          type: "sensitiveWords"
        }
      });
    },
    submitForm(ref) {
      this.$refs[ref].validate(async valid => {
        if (!valid) {
          return;
        }
        let data = {};
        data.name = this.wordsInfo.name;
        data.remark = this.wordsInfo.remark;
        if (this.wordsInfo.id) {
          data.id = this.wordsInfo.id;
        }
        if (!data.id) {
          await this.$http.post("/api/sensitiveWords", data);
          this.$Message.createSuccess();
        } else {
          await this.$http.put("/api/sensitiveWords/" + data.id, data);
          this.$Message.saveSuccess();
        }
        this.$refs.grid.refresh();
        this.showCreateWords = false;
      });
    },
    async delete(_ids) {
      await this.$http.delete(`/api/sensitiveWords/${_ids}`);
      this.$Message.deleteSuccess();
      this.search(1);
      this.selectList = [];
    },
    async editSensitiveWords(id) {
      this.$http.get(`/api/sensitiveWords/` + id).then(res => {
        this.showCreateWords = true;
        this.wordsInfo.id = res.id;
        this.wordsInfo.name = res.name;
        this.wordsInfo.remark = res.remark;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
